import $ from "jquery";
import setAlert from "./utils/set-alert";

const $flashCardSlider = $(".js-flash-card-slider");
if ($flashCardSlider.length) {
  const $document = $(document);
  const isRightToLeft = $("html").hasClass("right-to-left");

  $document.on("click", function ({ target }) {
    if (
      !(
        target.className.includes("js-flash-card-slider") ||
        target.closest(".js-flash-card-slider")
      )
    )
      $flashCardSlider.removeClass("focused");
  });

  // Flip card on click
  $document.on("click tap", ".js-flip-card", function ({
    target: { className: targetClassName },
  }) {
    if (
      targetClassName.includes("js-add-card-to-favorites") ||
      targetClassName.includes("fa-star") ||
      targetClassName.includes("js-text-to-speech") ||
      targetClassName.includes("fa-volume-up")
    )
      return;

    const $this = $(this);
    $this.toggleClass("flipped");
    $flashCardSlider.addClass("focused");
  });

  // On next/back, flip cards back
  $document.on("click tap", ".slick-arrow", function () {
    $(this)
      .closest(".flash-cards")
      .find(".js-flip-card.flipped")
      .removeClass("flipped");
    $flashCardSlider.addClass("focused");
  });

  // Save favorite
  $document.on("click tap", ".js-add-card-to-favorites", async function (e) {
    try {
      const $this = $(this);
      const { action, cardId } = $this.data();
      await $.post(`/${window.locale}/${action}-favorite-card/${cardId}`);
      $this.data("action", action === "save" ? "remove" : "save");
      const $starIcons = $(this).closest(".flip-card").find(".fa-star");
      $starIcons.toggleClass("far");
      $starIcons.toggleClass("fas");
    } catch (response) {
      console.warn(response);
      if (response.responseJSON) {
        const {
          responseJSON: { message, status },
        } = response;
        setAlert(status, message);
      }
    }
    $flashCardSlider.addClass("focused");
  });

  // Allow arrow key navigation
  $document.on("keydown", (e) => {
    if (!$flashCardSlider.hasClass("focused")) return;

    const { key } = e;
    $currentCard = $(".slick-current .js-flip-card");
    if (key === "ArrowUp" || key === "ArrowDown") {
      if (!$currentCard.length) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      $currentCard.toggleClass("flipped");
    } else if (key === "ArrowLeft") {
      $currentCard.removeClass("flipped");
      if (isRightToLeft) {
        $flashCardSlider.slick("slickNext");
      } else {
        $flashCardSlider.slick("slickPrev");
      }
    } else if (key === "ArrowRight") {
      $currentCard.removeClass("flipped");
      if (isRightToLeft) {
        $flashCardSlider.slick("slickPrev");
      } else {
        $flashCardSlider.slick("slickNext");
      }
    }
  });

  // Text to speech
  $document.on("click", ".js-text-to-speech", function () {
    const filename = $(this).data("filename");
    if (filename) {
      const audio = new Audio(`/uploads/tts/${filename}`);
      audio.play();
    }
  });

  // Hide quizlet embeds
  $('[data-oembed-url*="quizlet"]').addClass("d-none");
  $('iframe[src*="quizlet"]').addClass("d-none");
}
